<template>
    <div class="no-signal" :style="{marginTop: marginTop +'px'}">
        <template v-if="displayMode === 'vertical'">
            <i class="iconfont icon-sy-no-signal" :style="{fontSize: iconFontSize +'px', color: '#909399'}"></i>
            <div class="no-signal-text-gray">{{message}}</div>
            <div class="no-singla-retrybtn">
                <el-button type="danger" size="mini" @click="retry">点击重试</el-button>
            </div>
        </template>
        <template v-else-if="displayMode === 'horizental'">
            <div class="no-signal-text-black" @click="retry">{{message}}，点击重新加载</div>
        </template>
        <!-- 一般来说，重试的组件应该自己提供 loading 机制。
        <template v-if="retrying">
            <loading text="正在努力加载中" v-show="loading" :style-object="{fontSize: '36px', marginBottom: '20px', color: '#CB0101'}" :style-class="loadingClass"></loading>
        </template>
        -->
    </div>
</template>

<script>
    import {getMyHeader, GlobalLoading} from "../../utils";
    import {getConfs, getSlogans} from "../../data/commons";
    import {loadNewUserRewardPoint} from "../../data/user";

    export default {
        name: "NoSignal",
        props: {
            // vertical or horizental
            displayMode: {
                type: String,
                default: 'vertical'
            },
            marginTop: {
                type: Number,
                default: 0
            },
            iconFontSize: {
                type: Number,
                default: 50
            },
            message: {
                type: String,
                default: '网络不稳定'
            },
            retryBasis: {
                type: Boolean,
                default: false
            },  // 是否需要 retry basis functions
            retryHandlers: {
                type: Array,
                default: () => {return []}
            }  // an array of functions.
        },
        methods: {
            retry() {
                console.log('NoSignal retry...');
                GlobalLoading.start();
                setTimeout(()=>{
                    ( async()=> {
                        try {
                            if(this.retryBasis){
                                this.retryBasisHandlers();
                            }
                            for (let h of this.retryHandlers){
                                await h(); // 使用 await 的目的是延长加载的等待时间。
                                // h(); // 想了想为了支持并发加快响应速度，这里还是没有必要使用 await...
                            }
                        } finally {
                            GlobalLoading.stop();
                        }
                    })();
                }, 600) // 给足够的等待时间，不然一闪而过，有没有加载也不知道了。
            },
            // to retry those basis function
            async retryBasisHandlers(){
                console.log('NoSignal, retry basis handlers');
                // 注意这个顺序不要颠倒了，目的是确保 isSignedIn 一定执行成功后才重试 confs. 这样可以通过 header channel 控件重试。
                let basis = [this.__checkSignedInBasisHandler(), this.__reloadConfs()]
                for (let h of basis){
                    await h();
                }
            },
            // the basic retries.
            __checkSignedInBasisHandler(){
                console.log('no signal, get the check signed handler...');
                return getMyHeader().checkIsSignedIn
            },
            __reloadConfs(){
                console.log('no signal, get the retry reload confs handler');
                return getMyHeader().loadConfs
            },
            /**
             * @deprecated by __reloadConfs
             */
            __channelMenuBasisHandler(){
                console.log('no signal, retry get channel menu...');
                return getMyHeader().loadChannelMenu
            },
            /**
             * @deprecated by __reloadConfs
             */
            __slogansBasisHandler(){
                return getSlogans;
            },
            /**
             * @deprecated by __reloadConfs
             */
            __newUserRewardPointBasisHandler(){
                return loadNewUserRewardPoint;
            }
        }
    }
</script>

<style scoped>
    .no-signal{
        padding: 10px 0 10px 0;
    }
    .no-signal-text-gray{
        padding: 5px 0 5px 0;
        color: #909399
    }
    .no-signal-text-black{
        padding: 5px 0 5px 0;
        color: #606266
    }
    .no-singla-retrybtn{

    }
</style>



// WEBPACK FOOTER //
// src/components/commons/NoSignal.vue